module.exports = __webpack_public_path__ + "resources/img/img_credit_event3.13a2f88552954b004f76c96a8644926c.png";